var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",class:{'is-desktop': _vm.window.is.desktop, 'is-tablet': _vm.window.is.tablet, 'is-mobile': _vm.window.is.mobile, 'is-device': _vm.window.is.tablet || _vm.window.is.mobile}},[_c('com-head'),_c('com-body',[_vm._t("default")],2),_c('com-foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }